//components
import { BasicButton, CancelConfirmPanel, LoadingSpinner, CopyToClipboardButton } from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import CodeCharacters from './CodeCharacters';
import NotificationBar from  '@/components/elements/languages/NotificationBar';

//hooks
import UseCreateCodeModal from './CreateCodeModal.hooks';

//styling
import "../../../../../css/global/Modals/create-code-modal.scss";

const CreateCodeModal = ({showModal, onGenerateClick, hideModal} : {showModal: boolean, onGenerateClick: () => void,  hideModal: () => void}) => {
    const {onConfirmClick, isLoading, generatedCode, notificationDetails} = UseCreateCodeModal(showModal, onGenerateClick);

    return (
        <>
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="create-code-modal" 
            isFullPage
        >
                <div className="create-code-modal-content">
                    {generatedCode 
                        ?   (<div className="create-code-content recovery-code-content">
                                <h1 className='header-text'>Recovery Code</h1> 
                
                                <div>
                                    <span className='boldened-text'>
                                        This recovery code can only be viewed once.
                                    </span> 
                                    {` `}
                                    This is the user’s temporary code for signing in. After they use it, the code will expire and they will be required to create a new passkey.
                                </div>

                                <CodeCharacters 
                                    generatedCode={generatedCode}
                                />
                                
                                <div className='modal-button-panel'>
                                    <CopyToClipboardButton
                                        className={'copy-code-button'} 
                                        textToCopy={generatedCode}
                                    />
                                    <BasicButton 
                                        className='thrive-navy-style'
                                        content={"Close"} 
                                        ariaLabel={'Close modal'}
                                        onButtonClick={hideModal}                                    
                                    />
                                </div>
                            </div>)

                        :   
                            (<div className="create-code-content">
                                <h1 className='header-text'>Create Recovery Code</h1> 
                                
                                <div>
                                    This will generate a one-time recovery code the user can use to sign in and create a new passkey. Only continue if you’re sure they need this and you can deliver the code securely.
                                </div>

                            
                                <CancelConfirmPanel 
                                    cancelContent={'Cancel'} 
                                    confirmContent={isLoading ? <LoadingSpinner size={10}/> : 'Confirm'} 
                                    ariaLabelCancel={'Cancel and close modal'} 
                                    ariaLabelConfirm={'Confirm and generate code'} 
                                    onCancelClick={hideModal}
                                    onConfirmClick={onConfirmClick}
                                />
                            </div>)
                    }
                </div>
        </ModalWrapper> 

        {notificationDetails && 
            (
                <NotificationBar 
                    show={notificationDetails?.show} 
                    notificationStatus={notificationDetails?.status} 
                    msg={notificationDetails?.message} 
                />
            )
        }
        </>
    );  
}

export default CreateCodeModal;
